import { Component, OnInit } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { MsalService } from '@azure/msal-angular';
import { AboutComponent } from '../about/about.component';
import { Globals } from '../models/globals.model';
import { GlobalService } from '../services/global.service';
import { ThemeService } from '../services/theme.service';
import { notification } from '../models/interfaces/notifications';
/*NOSONAR
import { NotificationService } from '../services/notification-service';
import { AlertComponent } from '../common/alert/alert.component';
import { NotificationComponent } from '../notification/notification.component';
*/
import { MLService } from '../services/ml-service';
import { Tenant } from '../models/tenant.model';
import { TenantService } from '../services/tenant.service';
import { Refinery } from '../models/refinery.mode';


@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css']
})
export class NavBarComponent implements OnInit {

  userName: string;
  userShortName: string;
  notification: notification[] = [];
  unreadNotifications: number = 0;
  rbacName: string = '';
  countryCode: any;
  countryList: any;
  releaseDetails: any;
  /*NOSONAR
  zeroNotification = false;
  errorNotification = false;
  notificationLimit = 10;
  hideNotificationNumber = false;
  */
  dateString: string;
  tenantList: Tenant[];
  tenantName: string;
  tenantId: number;
  refineryName: string;
  refineryList: string[];
  refinerytMap: Refinery[];

  constructor(private readonly authService: MsalService, public mlServie: MLService,
    /*NOSONAR
    //public notificationService: NotificationService,
    */
    public globalsService: GlobalService,
    public dialog: MatDialog, public globals: Globals, public globalService: GlobalService,
    public themeService: ThemeService, public _router: Router,
    private readonly tenantService: TenantService) {
    this.countryList = [
      // <!-- THE BELOW FUNCTIONALITY BUTTONS ARE SET AS INACTIVE/COMMENTED SINCE THERE IS NO FUNCTIONALITIES ATTACHED TO IT AS OF NOW. -->
      {
        "Id": 1,
        "Name": "English",
        "Code": "EN",
      },
    ];

  }

  ngOnInit() {
    this.themeService.setDarkTheme();
    this.getReleaseDetails();
    this.countryCode = "EN";
    $('#handberg').click(function () {
      $('.row-offcanvas').toggleClass('active');
      $('.collapse').toggleClass('in').toggleClass('hidden-xs').toggleClass('visible-xs');
    });

    $("#close-sidebar").click(function () {
      $(".page-wrapper").removeClass("toggled");
    });
    $("#show-sidebar").click(function () {
      $(".page-wrapper").addClass("toggled");
    });
    this.tenantService.getTenants().subscribe((data: Refinery[]) => {
      let filterData = data.filter(item => item.tenantList[0] != undefined && item.tenantList.length > 0);
      this.refineryList = filterData.map(a => a.refineryName);
      this.refinerytMap = filterData;
      this.populateTenant(this.refineryList[0]);
    });
  }

  /**
   * used for refinery mapping
   * @param refineryName name of refinery
   */

  populateTenant(refineryName: string) {
    if (this.refinerytMap && this.refinerytMap.length > 0) {
      this.refinerytMap.some((u) => {
        if (refineryName === u.refineryName) {
          this.refineryName = refineryName;
          this.tenantList = u.tenantList;
          this.tenantName = this.tenantList[0].tenantName;
          this.onTenantChange(this.tenantList[0]);
        }
      })
    }
  }

  logout() {
    this.authService.logout();
  }

  // show about dialog for version, build date and build number
  openAboutRelease(): void {
     this.dialog.open(AboutComponent, {
        data: this.releaseDetails,
      }); 
  }
  /*NOSONAR
  //getNotification() {
  //  this.notificationService.getTopNotificationList().subscribe((data: any): void => {
  //    let notificationsList = data.Notifications;

  //    if (notificationsList && notificationsList.length > 0) {
  //      this.zeroNotification = false;
  //      this.notification = notificationsList.sort((a, b) => a.acknowledged - b.acknowledged);
  //      this.unreadNotifications = data.UnreadCount;
  //    } else if (notificationsList.length == 0) {
  //      this.unreadNotifications = 0;
  //      this.zeroNotification = true;        
  //    }
  //  }, (error: Error) => {
  //    this.errorNotification = true;
  //    this.globalsService.showAlert(AlertComponent, { success: false, message: "Error getting notifications" });
  //  });
  //}
  */
  getReleaseDetails() {
    this.releaseDetails = this.globals.releaseDetails;
  }
  /*NOSONAR
  //notificationOpen() {
  //  this.hideNotificationNumber = true;
  //  this.dateString = new Date().toISOString();
  //}

  //notificationClose() {
  //  this.hideNotificationNumber = false;
  //  this.notificationService.markReadTopNotification(this.dateString);
  //}
  */

  selectFlag(Code: any) {
    this.countryCode = Code;
  }

  toggleTheme() {
    if (this.themeService.isDarkTheme()) {
      this.themeService.setLightTheme();
    } else {
      this.themeService.setDarkTheme();
    }
  }

  goToHome() {
    window.location.href = this.globals.config.platformHomeUrl;
  }
  /*NOSONAR
  //showAllNotification() {
  //  this.globalService.openModelWindow(null, this, NotificationComponent, '80%', 'custom-modalbox', this.notification);
  //}
  */
  /**
  * Used for switching tenants and redirection to particular page
  * @param tenant tenant to be updated
  */
  onTenantChange(tenant: Tenant) {
    this.tenantName = tenant.tenantName;
    this.tenantId = tenant.tenantId;
    this.tenantService.setCurrentTenant(tenant);
    this._router.navigate(['Workflow']);
    /*NOSONAR
    this.getNotification();
    */
  }

}

